import {
  CurrencyRupeeIcon,
  BriefcaseIcon,
  HomeIcon,
} from "@heroicons/react/24/solid";

export default function LoanOptions() {
  const loans = [
    {
      icon: <CurrencyRupeeIcon className="text-white w-10 h-10" />,
      title: "Personal Loans",
      description:
        "Explore flexible financing options for your individual needs, from debt consolidation to unexpected expenses.",
      bg: "bg-blue-600",
      link: "/personal-loan", // 👈 route or URL
    },
    {
      icon: <BriefcaseIcon className="text-white w-10 h-10" />,
      title: "Business Loans",
      description:
        "Discover tailored solutions to fuel your business growth, manage cash flow, or invest in new opportunities.",
      bg: "bg-cyan-400",
      link: "#",
    },
    {
      icon: <HomeIcon className="text-white w-10 h-10" />,
      title: "Home Loans",
      description:
        "Find competitive rates and expert guidance to help you purchase your dream home or refinance your existing mortgage.",
      bg: "bg-sky-600",
      link: "#",
    },
  ];

  return (
    <div className="flex items-center justify-center p-6">
    <div className="max-w-4xl w-full space-y-6">
      {loans.map((loan, idx) => (
        <a
          key={idx}
          href={loan.link}
          className="flex items-center gap-4 bg-white rounded-2xl shadow p-4 hover:shadow-lg hover:bg-gray-50 transition cursor-pointer"
        >
          {/* Icon box */}
          <div
            className={`${loan.bg} w-20 h-20 flex items-center justify-center rounded-lg`}
          >
            {loan.icon}
          </div>

          {/* Text */}
          <div>
            <h3 className="font-bold text-lg">{loan.title}</h3>
            <p className="text-gray-600 text-sm">{loan.description}</p>
          </div>
        </a>
      ))}
    </div>
    </div>
  );
}
